import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { isMenuOpenVar } from 'core/api/apollo/cache';
import { Box } from 'core/ui/atoms';
import { ReactComponent as CloseIcon } from 'core/assets/images/V2/icons/CloseIcon.svg';
import { ReactComponent as MenuIcon } from 'core/assets/images/V2/icons/MenuIcon.svg';

class MobileNavClose extends PureComponent {
  static propTypes = {
    opened: PropTypes.bool,
  };

  toggleMenu = (e) => {
    e.preventDefault();
    isMenuOpenVar(!isMenuOpenVar());
  }

  render() {
    const { opened } = this.props;

    if (opened) {
      return (
        <CloseCont onClick={this.toggleMenu}>
          <CloseIcon />
        </CloseCont>
      );
    } else {
      return (
        <MenuCont onClick={this.toggleMenu} hiddenMD hiddenLG>
          <MenuIcon />
        </MenuCont>
      );
    }
  }
}

const CloseCont = styled(Box)`
  position: relative;
  width: 25px;
  height: 25px;
  z-index: 10;
  cursor: pointer;
  top: 20px;
  left: 20px;
`;

const MenuCont = styled(Box)`
  position: relative;
  width: 25px;
  height: 25px;
  z-index: 10;
  cursor: pointer;
  left: 15px;
`;

export default MobileNavClose;
